document.addEventListener('DOMContentLoaded', function () {
	if( ! document.querySelector('.profile-picture-wrapper')) {
		return;
	}
	
	const imageInputWrapper = document.querySelector('.profile-picture-wrapper');
	if (imageInputWrapper) {
		const imageInput = document.getElementById('profile-image-upload');
		if (imageInput) {
			imageInput.addEventListener('change', function (event) {
				const file = event.target.files[0];
				if (file && file.type.startsWith('image/')) {
					const reader = new FileReader();
					reader.onload = function (e) {
						const profilePicture = document.querySelector('.profile-picture');
						if (profilePicture) {
							profilePicture.src = e.target.result;
						}
					};
					reader.readAsDataURL(file);

					document.getElementById('profile-change').value = 'change';
				}
			});
		}
	}
});